import React from 'react'

// navigation
import { getSteps, getCurrentStep } from 'lib/helpers/registration/navigation'

// material-ui
import Hidden from '@mui/material/Hidden'

// shared components
import AccountNotifications from 'components/shared/AccountNotifications'

// local components
import MobileHeader from './MobileHeader'
import MobileNav from './MobileNav'
import DesktopHeader from './DesktopHeader'
import DesktopNav from './DesktopNav'

const Header = props => {
  const {
    account,
    basename, // via rails
    loading, // via withQuery
    pathname // via withPathname
  } = props

  const { preferences } = account || {}
  const { onlineOnly = true } = preferences || {}

  const currentStep = getCurrentStep({ pathname, onlineOnly })
  const steps = getSteps({ onlineOnly })

  const headerTitle = currentStep.header

  return (
    <>
      <Hidden smUp>
        <MobileHeader
          account={account}
          loading={loading}
          title={headerTitle}
          nav={
            <MobileNav
              account={account}
              onlineOnly={onlineOnly}
              steps={steps}
              currentStep={currentStep}
            />
          }
        />
      </Hidden>
      <Hidden smDown>
        <DesktopHeader account={account} title={headerTitle} />
        <DesktopNav
          account={account}
          onlineOnly={onlineOnly}
          steps={steps}
          currentStep={currentStep}
        />
      </Hidden>
      <AccountNotifications account={account} basename={basename} />
    </>
  )
}

export default Header
